import React, {useEffect} from "react";
import ActivityContent from "./activity-content.jsx";
import CardsContent from "./cards-content.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";

const ReportContent = ({ data, boName, showDetails }) => {

    useEffect(() => {
        ReportUtils.withoutContentReadjust();
    }, [data]);

    useEffect(() => {
        if (!data?.result?.length) return;

        const activityValues = [];
        const garrisonValues = [];
        const dispatchValues = [];
        const boValues = [];
        const materialCautionValues = [];

        data.result.forEach(activity => {

            activityValues.push([
                activity.onduty ?? "",
                activity.inspector ?? "",
                activity.observation ?? ""
            ]);

            activity.garrisonData?.forEach(garrison => {
                let total = "Inconsistente";
                if (garrison.initialmileage && garrison.finalmileage && parseInt(garrison.finalmileage) >= parseInt(garrison.initialmileage)) total = garrison.finalmileage - garrison.initialmileage;

                let garrisonName = garrison.garrison_name;

                garrisonValues.push([
                    garrison.garrison_start ?? "",
                    garrison.garrison_end ?? "",
                    garrison.garrison_team ?? "",
                    garrison.sectors ?? "",
                    garrison.garrison_initialobservation ?? "",
                    garrison.observation ?? "",
                    garrisonName ?? "",
                    garrison.integrants ?? "",
                    garrison.initialmileage ?? "",
                    garrison.finalmileage ?? "",
                    total,
                    garrison.animals ?? ""
                ]);

                garrison.materialCaution?.forEach(material => {
                    materialCautionValues.push([
                        garrisonName ?? "",
                        material.material ?? "",
                        material.serial ?? "",
                        material.asset ?? "",
                        material.caution_date ?? "",
                        material.return_date ?? "",
                        material.responsible_name ?? ""
                    ]);
                });

                garrison.dispatch?.forEach(dispatch => {
                    dispatchValues.push([
                        garrisonName ?? "",
                        dispatch.numbercheckbook ?? "Sem talão",
                        dispatch.occurrencenumber ?? "",
                        dispatch.dstart ?? "",
                        dispatch.dend ?? "",
                        dispatch.nature ?? "",
                        dispatch.neighborhood ?? "",
                        dispatch.street ?? "",
                        dispatch.factnumber !== '-' ? dispatch.factnumber : "Não informado",
                        dispatch.finalobservation ?? ""
                    ]);
                });
            });

            activity.boData?.forEach(bo => {
                boValues.push([
                    bo.numbercheckbook ?? "Sem talão",
                    bo.bogcmid ?? "",
                    bo.nature ?? "",
                    bo.neighborhood ?? "",
                    bo.observation ?? ""
                ]);
            });

        });

        ReportUtils.createExportableTable(["Plantão", "Cadastrado por", "Observação final"], activityValues, "Diários");

        if (garrisonValues) ReportUtils.createExportableTable(["D/H inicial", "D/H final", "Equipe", "Setor", "Obs. inicial", "Obs. plantão", "Guarnição",
        "Contingentes", "Km inicial", "Km final", "Km percorrido", "Animais"], garrisonValues, "Guarnições");

        if (showDetails && dispatchValues.length > 0) ReportUtils.createExportableTable(["Guarnição", "Talão", `Nº ${boName}`, "D/H inicial", "D/H final", "Natureza", "Bairro", "Logradouro",
        "Número", "Obs. final"], dispatchValues, "Despachos");

        if (showDetails && boValues.length > 0) ReportUtils.createExportableTable(["Despacho", `Nº ${boName}`, "Natureza", "Bairro", "Resumo"], boValues, `${boName}`);

        if (showDetails && materialCautionValues.length > 0) ReportUtils.createExportableTable(["Guarnição", "Material", "Nº de série", "Nº de patrimônio",
        "Retirada", "Devolução", "Integrante"], materialCautionValues, "Materiais em cautela");

    }, [data]);

    if (!data || !data.result || data.result.length === 0) return null;

    return (
        <div className={'journal-report'}>
            <CardsContent data={data} boName={boName}/>

            {data.result.map((item, index) => (
                <ActivityContent key={index} data={item} boName={boName} showDetails={showDetails}/>
            ))}
        </div>
    );
};

export default ReportContent;